import { QueryClient } from '@tanstack/react-query'

const RETRYABLE_ATTEMPTS = 2

/**
 * Client errors are never retried — only transport failures and 5xx are worth a
 * second attempt.
 */
const shouldRetry = (failureCount, error) => {
  if (failureCount >= RETRYABLE_ATTEMPTS) return false
  const status = error?.status
  if (error?.isNetworkError) return true
  return typeof status === 'number' && status >= 500
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: shouldRetry,
      refetchOnWindowFocus: false,
      throwOnError: false,
    },
    mutations: {
      retry: false,
    },
  },
})
